import styled from 'styled-components';
import { badgeCardBg, black, cardBorder } from '../../../utils/style/colors';

interface MinimizedItemProps {
  isOpen: boolean;
}

export const MinimizedItem = styled.div<MinimizedItemProps>`
  background-color: ${({ isOpen }) =>
    isOpen ? 'var(--black)' : 'var(--exact-white)'};
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 300;
  border-radius: 0.5rem;
  margin: 10px 5px;
  height: 30px;
  & > li {
    line-height: 2rem;
    & > span {
      font-weight: 300;
      color: ${({ isOpen }) =>
        isOpen ? 'var(--exact-white)' : 'var(--black)'};
    }
  }
  padding: 0px 10px;
`;

export const OpenItems = styled('ul')`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 1rem auto;
  gap: 0.5rem;
`;

export const MinimizedItemCotainer = styled.div`
  height: 2.5rem;
  width: 12.5rem;
  gap: 0.5rem;
  border-radius: 1rem;
  border: ${cardBorder};
  display: flex;
  flex-direction: row;
  overflow: hidden;

  &:hover {
    cursor: pointer;
  }
`;

export const MinimizedItemBadgeContainer = styled.div`
  width: 10rem;

  ${(props) =>
    `background-image: linear-gradient(to ${props.theme.direction === 'rtl' ? 'left' : 'right'}, ${props.color} 0%, var(--exact-white) 100%);`}
  color: var(--exact-white);
  display: flex;
  align-items: center;
  justify-content: start;
  padding-inline-start: 0.75rem;
`;

export const MinimizedItemContentContainer = styled.div`
  margin-inline-start: -7rem;
  font-weight: bold;
  font-size: 0.8rem;

  display: flex;
  align-items: center;
  justify-content: center;

  flex-grow: 1;
  border-radius: 1rem;
  flex-direction: column;
  text-align: center;
  color: ${black};
  background: ${(props) => (props.isOpen ? 'transparent' : badgeCardBg)};
  border-inline-start: ${(props) => (props.isOpen ? 'none' : cardBorder)};
`;
